// extracted by mini-css-extract-plugin
export default {"marker":"MapModalFull_marker__I3yhK"};